import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { CheckCircleIcon } from 'assets';
import StyledBadge from 'components/shared/StyledBadge/StyledBadge';
import StyledButton from 'components/shared/StyledButton/StyledButton';
import { CLIENT_ORDERS } from 'constants/routes';
import WithAuth from 'hoc/withAuth';
import { AddressData } from 'interfaces';

import styles from './OrderSuccessPage.module.css';

interface LocationState {
   logisticMinimum: boolean;
   deliveryType: AddressData | 'SELF_PICKUP';
}

export const OrderSuccessPage = () => {
   const { t } = useTranslation();
   const data = useLocation().state as LocationState;
   const logisticMinimum = data.logisticMinimum;
   const deliveryType = data.deliveryType;

   return (
      <div className={styles.container}>
         <div className={styles.innerContainer}>
            <CheckCircleIcon />
            <h2>
               {!logisticMinimum || deliveryType === 'SELF_PICKUP'
                  ? t('orderSuccessPage.requestSent')
                  : t('orderSuccessPage.orderPlaced')}
            </h2>

            {!logisticMinimum || deliveryType === 'SELF_PICKUP' ? (
               <div className={styles.textSection}>
                  <p>
                     {t('orderSuccessPage.contactSoonLine1')}
                     <br />
                     {t('orderSuccessPage.contactSoonLine2')}
                  </p>
                  <div className={styles.textBadgeRow}>
                     <p>{t('orderSuccessPage.orderStatusInfo')}</p>
                  </div>
                  <StyledBadge variant="WAITING" text={t('order.status.waiting')} />
                  {deliveryType === 'SELF_PICKUP' && <p>{t('orderSuccessPage.pickupInfo')}</p>}
               </div>
            ) : (
               <div className={styles.textSection}>
                  <p>{t('orderSuccessPage.waitForAccept')}</p>
                  <StyledBadge variant="WAITING" text={t('order.status.waiting')} />
                  <p>{t('orderSuccessPage.acceptSoon')}</p>
               </div>
            )}

            <Link to={CLIENT_ORDERS}>
               <StyledButton
                  style={{ marginTop: 45 }}
                  text={t('orderSuccessPage.orderList')}
                  variant="outlined-primary"
               />
            </Link>
         </div>
      </div>
   );
};

export default WithAuth(OrderSuccessPage, 'ROLE_CLIENT');
